import Vue from 'vue'
import App from './App'
import moment from 'moment';
import router from '@/router/'
import { sync } from "vuex-router-sync";
import VueMeta from 'vue-meta';
import { store } from './store'
import ApiService from '@/services/api.service'
import TokenService from '@/services/storage.service'
import BootstrapVue from 'bootstrap-vue'
import '@/scss/main.scss';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { library } from "@fortawesome/fontawesome-svg-core";
import { faArrowRight, faCalendarAlt, faCalendarPlus, faUserEdit, faUserFriends, faArrowLeft, faQuestionCircle, faMinusCircle, faPlusCircle, faTrashAlt, faUser } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
window.LC_Event = new Vue();
Vue.config.productionTip = false;
const vue_app_root_api = process.env.NODE_ENV == 'development' ? process.env.VUE_APP_ROOT_API : process.env.VUE_APP_ROOT_API_STAGE;
// console.log(vue_app_root_api);
ApiService.init(vue_app_root_api)

if (TokenService.getToken()) {
    ApiService.setHeader();
}
// load bootstrap
Vue.use(BootstrapVue);

// add FA Icon(s)
library.add(faArrowRight);
library.add(faArrowLeft);
library.add(faCalendarAlt);
library.add(faCalendarPlus);
library.add(faUserFriends);
library.add(faUserEdit);
library.add(faUser);
library.add(faQuestionCircle);
library.add(faMinusCircle);
library.add(faPlusCircle);
library.add(faTrashAlt);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.filter(
    'format_date', 
    date => { 
        moment.locale('de-DE'); 
        return moment(date).format('dd DD.MM.YYYY');
    }
);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
});

//Sync vue-router's current $route as part of vuex store's state.
sync(store, router);

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')